import React, { useState, useEffect } from "react";
import { Select, message, Button } from "antd";
import { countries } from "../constant/countery";
import { putRequest } from "../service/index";

const EditLocation = (props) => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    locationName: "",
    country: "",
    city: "",
    zipCode: "",
    address: ""
  });
  const { onClose, location } = props;

  // Initialize form data with location data when component mounts or location changes
  useEffect(() => {
    if (location) {
      setFormData({
        locationName: location.locationName || "",
        country: location.country || "",
        city: location.city || "",
        zipCode: location.zipCode || "",
        address: location.address || ""
      });
    }
  }, [location]);

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [id]: value
    }));
  };

  const handleCountryChange = (value) => {
    setFormData(prev => ({
      ...prev,
      country: value
    }));
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const response = await putRequest(`/api/companies/locations?locationId=${location._id}`, formData);
      if (!response.error) {
        message.success("Location updated successfully!");
        onClose();
      } else {
        message.error(response.error || "Failed to update location!");
      }
    } catch (error) {
      message.error("Failed to update location. Please try again.");
      console.error("Error updating location:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col gap-3">
      <div className="grid grid-cols-12 gap-3">
        <div className="col-span-6 flex flex-col gap-1">
          <label htmlFor="locationName" className="text-md">
            Work Location
          </label>
          <input
            type="text"
            id="locationName"
            className="border border-gray-400 outline-hidden px-2 py-1 rounded-md text-md"
            placeholder="Enter work location"
            value={formData.locationName}
            onChange={handleInputChange}
          />
        </div>
        <div className="col-span-6 flex flex-col gap-1">
          <label htmlFor="country" className="text-md">
            Country
          </label>
          <Select
            showSearch
            placeholder="Select a country"
            optionFilterProp="value"
            value={formData.country}
            onChange={handleCountryChange}
            filterOption={(input, option) =>
              (option?.value ?? '').toLowerCase().includes(input.toLowerCase())
            }
            options={countries.map(country => ({
              value: country.value,
              label: country.value
            }))}
            className="w-full"
          />
        </div>
        <div className="col-span-6 flex flex-col gap-1">
          <label htmlFor="city" className="text-md">
            City
          </label>
          <input
            type="text"
            id="city"
            className="border border-gray-400 outline-hidden px-2 py-1 rounded-md text-md"
            placeholder="Enter city"
            value={formData.city}
            onChange={handleInputChange}
          />
        </div>
        <div className="col-span-6 flex flex-col gap-1">
          <label htmlFor="zipCode" className="text-md">
            Zip Code
          </label>
          <input
            type="text"
            id="zipCode"
            className="border border-gray-400 outline-hidden px-2 py-1 rounded-md text-md"
            placeholder="zip code"
            value={formData.zipCode}
            onChange={handleInputChange}
          />
        </div>
        <div className="col-span-12 flex flex-col">
          <label htmlFor="address" className="text-md">
            Address
          </label>
          <textarea
            id="address"
            className="border border-gray-400 outline-hidden px-2 py-1 rounded-md text-md"
            rows={3}
            value={formData.address}
            onChange={handleInputChange}
          ></textarea>
        </div>
      </div>
      <div className="flex items-center justify-end gap-3 my-2">
        <Button onClick={onClose} disabled={loading}>Cancel</Button>
        <Button
          onClick={handleSubmit}
          loading={loading}
          type="primary"
          className="bg-primary text-white"
        >
          {loading ? "Updating..." : "Update Location"}
        </Button>
      </div>
    </div>
  );
};

export default EditLocation;
